import React, { FC } from 'react';
import DropDown from './DropDown';
import { createUseStyles } from 'react-jss';
import ProfileCard from './ProfileCard';
import { HiOutlineUser as UserIcon } from '@react-icons/all-files/hi/HiOutlineUser';
import { HiOutlineCog as PreferenceIcon } from '@react-icons/all-files/hi/HiOutlineCog';
import { HiOutlineLogout as LogoutIcon } from '@react-icons/all-files/hi/HiOutlineLogout';
import ProfileMenuItem from './ProfileMenuItem';
import { LegacyUser } from 'src/interfaces/api/User';
import useAuth from 'src/hooks/api/useAuth';

const linkToProfile = '/dashboard/user/';
const linkToSettings = '/dashboard/settings';

const useStyles = createUseStyles({
  button: {
    cursor: 'pointer',
  },
  menuHeader: {
    '& .title': {
      fontSize: '.875rem',
      color: '#6c757d',
    },
  },
  menu: {
    width: 170,
  },
});

interface MenuItem {
  label: string;
  icon: any;
  onClick: () => void;
}

interface Props {
  navigateTo?: any;
  user?: LegacyUser;
  className?: any;
}

const ProfileDropDown: FC<Props> = ({ navigateTo, user, className }) => {
  const classes = useStyles();
  const { logout } = useAuth();

  const menuItems: MenuItem[] = [
    { label: 'Mon Profil', icon: UserIcon, onClick: () => navigateTo(linkToProfile + user?.id) },
    { label: 'Mes préférences', icon: PreferenceIcon, onClick: () => navigateTo(linkToSettings) },
    { label: 'Déconnexion', icon: LogoutIcon, onClick: logout },
  ];

  return (
    <DropDown
      className={className}
      menuClassName={classes.menu}
      headerClassName={classes.menuHeader}
      title={`${user?.firstname || '____'} ${user?.lastname || '____'}`}
      buttonComponent={(props) => <ProfileCard className={classes.button} user={user} {...props} />}
      renderDropDownItem={(item, key) => (
        <ProfileMenuItem key={key} label={item.label} icon={item.icon} onClick={item.onClick} />
      )}
      list={menuItems}
    />
  );
};

export default React.memo(ProfileDropDown, (prevProps, nextProps) => prevProps.user === nextProps.user);
